export const SET_SYSTEM_SETTING = "SET_SYSTEM_SETTING";
export const SAVE_USER_SETTING = "SAVE_USER_SETTING";
export const SET_SPEECH_VOICES = "SET_SPEECH_VOICES";
export const GET_SPEECH_VOICES = "GET_SPEECH_VOICES";
